import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "info-2",
  "use": "info-2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"info-2\"><path d=\"M24 18H11l-7 5v-5H0V1h24v17zM23 2.2H1v14.3h4.4v4.4l4.8-4.4H23V2.2zM13 9v5h-2V9h2zm-1-1.5c.7 0 1.3-.6 1.3-1.3S12.7 5 12 5s-1.3.6-1.3 1.3.6 1.2 1.3 1.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/info-2.svg
// module id = FYU3
// module chunks = 1